import { GlobalizationConfig } from 'src/app/shared/interfaces/globalization-config.interface';
import { ProcessStatusEnum } from 'src/app/shared/interfaces/process.interface';
import { AttributeType } from 'src/app/shared/modals/filters/models/filter-models';
import {AttributeItem} from '../../users/_interfaces/users-admin';
import { AreaConfigAttributeAction } from './area-config.interface';

export interface Evaluated360User {
    userId: string;
    imageUrl: string;
    name: string;
    status: ProcessStatusEnum;
    attribute1?: string;
    attribute2?: string;
    flags: Array<string>;
    qualifier: string;
    subjectUserId: string;
    lineManager: string;
    cycleParticipantId: number;
    selectedCount?: number;
    maxEvaluators?: number;
    minEvaluators?: number;
    evaluationSelectionCount?: number;
    aboveSelectionLimit?: boolean;

    rank?: string;
    area?: string;
    attributes?: AttributeItem[];

    isManager?: boolean;
    isManagerEvaluation?: boolean;
    areaId?: number;
    areaEvaluators?: Array<AreaEvaluators>;
    usersOfArea?: number;
    reopeningDueDate?: Date;
}

export enum Evaluation360Status {
    NotSent = 0,
    Sent = 1
}

export interface AreaEvaluators {
    area?: GlobalizationConfig;
    areaId?: number;
    attributeType?: AttributeType;
    attributeAction?: AreaConfigAttributeAction;
    evaluators?: Array<Evaluated360User>;
    usersOfArea?: number;

    showSearch?: boolean;
}
